<template>
  <div class="container min-body-height" :class="UI.isMobile ? '' : 'padding-top'">
    <div
      class="flex align-center justify-between"
      :class="UI.isMobile ? 'flex-direction' : ''"
    >
      <h1>新闻公告</h1>

      <el-form
        :inline="!UI.isMobile"
        :label-position="UI.isMobile ? 'top' : 'right'"
        size="mini"
        :model="filterForm"
      >
        <el-form-item label="标题">
          <el-input v-model="filterForm.title" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              page = 1;
              flushData();
            "
          >
            查询
          </el-button>
          <el-button
            @click="
              filterForm = { page: 1, page_size: 10 };
              flushData();
            "
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>

    <el-table
      class="margin-top"
      :data="tableData"
      style="width: 100%"
      :show-header="false"
      header-row-class-name="bg-default"
      :row-class-name="tableRowClassName"
      @cell-click="cellClick"
    >
      <el-table-column
        prop="title"
        label="标题"
      ></el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getNoticesList } from '@/servers/homepage.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    flushData: function() {
      let that = this;
      this.page = 1;
      getNoticesList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'bg-gray cursor-pointer';
      } else {
        return 'bg-white cursor-pointer';
      }
    },

    cellClick: function(row, column, cell, event) {
      this.$router.push({
        name: 'news',
        query: { id: row.id, cate: 'notice' },
      });

      // const url = this.$router.resolve({
      //   name: 'gameInfo',
      //   query: { id: row.id },
      // });
      // window.open(url.href, '_blank');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/news/newsList.vue